import { render } from "./BookingsSnippet.vue?vue&type=template&id=5e47b987"
import script from "./BookingsSnippet.vue?vue&type=script&lang=js"
export * from "./BookingsSnippet.vue?vue&type=script&lang=js"

import "./BookingsSnippet.vue?vue&type=style&index=0&id=5e47b987&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__